module.exports = __webpack_public_path__ + "041ef54e0a038e49c583c220faf6431a.svg";